import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
});

export async function getBusinessStatus(token, salonId) {
  const url = salonId
    ? `${API}/business/status?salon_id=${encodeURIComponent(salonId)}`
    : `${API}/business/status`;
  const res = await axios.get(url, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getBusinessProfile(token) {
  const res = await axios.get(`${API}/business`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateBusinessProfile(data, token) {
  const res = await axios.put(`${API}/business`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function getBusinessHours(token, salonId) {
  const url = salonId
    ? `${API}/business/hours?salon_id=${encodeURIComponent(salonId)}`
    : `${API}/business/hours`;
  const res = await axios.get(url, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function saveBusinessHours(hours, token, salonId) {
  const url = salonId
    ? `${API}/business/hours?salon_id=${encodeURIComponent(salonId)}`
    : `${API}/business/hours`;
  const res = await axios.put(url, hours, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function getTaxSettings(token) {
  const res = await axios.get(`${API}/business/tax-settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function saveTaxSettings(data, token) {
  const res = await axios.put(`${API}/business/tax-settings`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function getKPISettings(token) {
  const res = await axios.get(`${API}/business/kpi-settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function saveKPISettings(data, token) {
  const res = await axios.put(`${API}/business/kpi-settings`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function getOnlineBookingSettings(token) {
  const res = await axios.get(`${API}/business/online-booking/settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function saveOnlineBookingSettings(data, token) {
  const res = await axios.put(`${API}/business/online-booking/settings`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function getRentalSettings(token) {
  const res = await axios.get(`${API}/business/rentals/settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function saveRentalSettings(data, token) {
  const res = await axios.put(`${API}/business/rentals/settings`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function resetOnboardingDraft(token) {
  const res = await axios.post(
    `${API}/business/onboarding/reset`,
    null,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function completeOnboarding(token, salonId) {
  const url = salonId
    ? `${API}/business/onboarding/complete?salon_id=${encodeURIComponent(salonId)}`
    : `${API}/business/onboarding/complete`;
  const res = await axios.post(url, null, {
    headers: authHeaders(token),
  });
  return res.data;
}
